
            const data = {"name":"chevron-up","data":{"width":"16","height":"17","viewBox":"0 0 16 17","data":"<path pid=\"0\" d=\"M15.707 11.8a1 1 0 0 1-1.414 0L8 5.509 1.707 11.8a1 1 0 0 1-1.414-1.415l6.293-6.292a2 2 0 0 1 2.828 0l6.293 6.292a1 1 0 0 1 0 1.415Z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    